import { AuthenticationSliceShape } from './reducer';

export const authenticationTokenSelector = (state: AuthenticationSliceShape) => state.authentication.token;
export const authenticationTokenPayloadSelector = (state: AuthenticationSliceShape) => state.authentication.tokenPayload;
